import { Component } from "@theme/component";
import { DialogComponent } from "@theme/dialog";

/**
 * A custom element that manages the main menu drawer.
 *
 * @typedef {object} Refs
 * @property {DialogComponent} successDialog - The details element.
 *
 * @extends {Component<Refs>}
 */

class CustomFormComponent extends Component {
  requiredRefs = ["successDialog"];

  connectedCallback() {
    super.connectedCallback();
    this.checkFormPostedSuccess();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  checkFormPostedSuccess = () => {
    const params = new URLSearchParams(window.location.search);
    const paramName = this.dataset.param || "contact_posted";
    // Controlla se il parametro esiste
    const isPosted = params.get(paramName) === "true";
    if (isPosted) {
      this.refs.successDialog.showDialog();
    }
  };

  closeSuccessDialog() {
    this.refs.successDialog.closeDialog();
    // Ricrea l'URL con solo contact_posted
    const newParams = new URLSearchParams();
    newParams.set(this.dataset.paramName || "contact_posted", "true");

    // Mantieni solo /path?contact_posted=true
    const cleanUrl =
      window.location.origin +
      window.location.pathname +
      "?" +
      newParams.toString();
    history.replaceState(null, "", cleanUrl);
  }
}

if (!customElements.get("custom-form-component")) {
  customElements.define("custom-form-component", CustomFormComponent);
}
